import {
  Datagrid,
  FunctionField,
  List,
  RichTextField,
  TextField as RATextField,
  useListContext,
  
} from "react-admin";
import { useState } from "react";
import {Box, TextField as MuiTextField } from "@mui/material";

const FeedbacksDatagrid = () => {
  const { data, isLoading } = useListContext();
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  if (isLoading) return null;

  const filteredData = data.filter((record) => {
    const s = search.toLowerCase();

    const matchesSearch =
      record.phonenumber?.toLowerCase().includes(s) ||
      record.email?.toLowerCase().includes(s) ||
      record.inquiry?.toLowerCase().includes(s);

    const createdAt = new Date(record.created_at);

    const matchesDate =
      (!startDate || createdAt >= new Date(startDate)) &&
      (!endDate || createdAt <= new Date(endDate));

    return matchesSearch && matchesDate;
  });

  return (
    <>
     <Box display="flex" flexWrap="wrap" gap={2} p={2}>
  <MuiTextField
    label="Search"
    value={search}
    onChange={(e) => setSearch(e.target.value)}
  />
  <MuiTextField
    label="Start Date"
    type="date"
    value={startDate}
    onChange={(e) => setStartDate(e.target.value)}
    InputLabelProps={{ shrink: true }}
  />
  <MuiTextField
    label="End Date"
    type="date"
    value={endDate}
    onChange={(e) => setEndDate(e.target.value)}
    InputLabelProps={{ shrink: true }}
  />
</Box>
   
      <Datagrid data={filteredData}>
        <RATextField source="phonenumber" />
        <RATextField source="email" />
        <RichTextField source="inquiry" />
        <FunctionField
          label="Created At"
          render={(record) =>
            `${new Date(record.created_at).toLocaleString()} `
          }
        />
      </Datagrid>
    </>
  );
};

export const FeedbacksList = (props) => (
  <List {...props}>
    <FeedbacksDatagrid />
  </List>
);
